import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import routes from "./router/route";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/SrollToTop/ScrollToTop";
import "./App.css";
import "./assets/css/style.scss";
import HeaderMenu from "./components/layout/HeaderMenu";
import Toast from "./components/common-footer/Toast";
import { checkAutoLogout } from "./utils/auth";

const App = () => {
  // 30분 자동 로그아웃 체크
  useEffect(() => {
    // 컴포넌트 마운트 시 즉시 체크
    checkAutoLogout();
    
    // 1분마다 체크 (30분 경과 여부 확인)
    const interval = setInterval(() => {
      checkAutoLogout();
    }, 60000); // 1분 = 60000ms
    
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      {/* <Header /> */}
      {/* <Header /> */}
      <HeaderMenu />
      <main className="wrapper-content">
        <Routes>
          {routes.map(({ path, element }, i) => (
            <Route key={i} path={path} element={element} />
          ))}
        </Routes>
      </main>
      <Footer />
      <Toast />
    </div>
  );
};

export default App;
